import * as THREE from "three";
import { GetSettings } from "./Settings";

exports.Unify = function(unify) {
  this.unify_id = "gameLogic";

  const settings = GetSettings();

  const playerStats = {
    health: 100,
    score: 0,
    kills: 0,
    powerUp: false,
    isHunted: false
  };
  unify.addNewAsset("playerStats", playerStats);

  let happyNugs = null;
  let evilNugs = null;
  let lastFoundObject = null;
  let foundNewObject = false;

  let throttleFrameCount = 0;
  let worldResetTime = 0;
  let worldState = 0; // 0: neutral, 1: good, 2: bad
  let terrainModule;
  let sounds = null;
  this.countdown = settings.countdown;
  let gameStarted = false;

  const worldStateCallbacks = [];

  const checkIfNewFoundObject = obj => {
    if (obj != lastFoundObject) {
      foundNewObject = true;
      lastFoundObject = obj;
    } else {
      foundNewObject = false;
    }
    return foundNewObject;
  };

  // -----------------------------------------------------------------------------------
  // Awake
  // -----------------------------------------------------------------------------------
  this.awake = () => {
    terrainModule = unify.modules.terrain;
    sounds = unify.modules.sounds;
    unify.addNewAsset(unify.camera, "player");
  };

  // -----------------------------------------------------------------------------------
  // Start
  // -----------------------------------------------------------------------------------
  this.onLoaded = () => {
    this.target = new THREE.Vector3(0, 0, 0);
    this.happyObjectMeshes = unify.assets.happyObjects;
    this.evilObjectMeshes = unify.assets.evilObjects;
    this.triggerDist = settings.triggerDistance;

    happyNugs = unify.assets.happyTuneNuggets;
    evilNugs = unify.assets.evilTuneNuggets;

    // debug controls (FOR PLAY TESTING ONLY)
    unify.input.addKeyDown(setWorldStateNeutral, "0");
    unify.input.addKeyDown(setWorldStateGood, "1");
    unify.input.addKeyDown(setWorldStateBad, "2");
    // Add time to countdown timer:
    unify.input.addKeyDown(addCountdown, "t");
    // Add score to win fast:
    unify.input.addKeyDown(addScore, "h");
  };

  this.start = () => {
    // set init world state
    setWorldState(-1);
    // subscribe start button
    unify.input.addMouseDown(startGame, "left");
  };

  // -----------------------------------------------------------------------------------
  // Update
  // -----------------------------------------------------------------------------------
  this.update = deltaTime => {
    if (throttleFrameCount == settings.nuggetDistanceUpdateInterval) {
      //test distance to happy nuggets
      if (happyNugs != null) {
        for (let i = 0; i < happyNugs.length; i++) {
          let tempDist = unify.assets.player.getWorldPosition(this.target).distanceTo(happyNugs[i].position);
          if (tempDist <= this.triggerDist && !happyNugs[i].isFound) {
            // new object?
            if (checkIfNewFoundObject(happyNugs[i])) {
              if (!happyNugs[i].isFound) {
                happyNugs[i].isFound = true;
                if (sounds) happyNugs[i].sound.stop();

                unify.modules.tuneNuggets.swapNuggetMesh(happyNugs[i]);
                unify.assets.playerStats.score++;
                this.playerHealth(settings.happyNuggetAddHealth);
              }
              setWorldState(1);
            }
          }
        }
      }
      // test distance to evil nuggets
      if (evilNugs != null && worldState != 1) {
        for (let i = 0; i < evilNugs.length; i++) {
          let tempDist = unify.assets.player.getWorldPosition(this.target).distanceTo(evilNugs[i].position);
          if (tempDist <= this.triggerDist) {
            // new object?
            if (checkIfNewFoundObject(evilNugs[i])) {
              if (!evilNugs[i].isFound) {
                evilNugs[i].isFound = true;
                unify.modules.tuneNuggets.swapNuggetMesh(evilNugs[i]);
                //evilNugs[i].sound.stop();

                this.glitch(800);
              }
              setWorldState(2);
            }
          }
        }
      }
      throttleFrameCount = 0;
    }

    //world state check, reset
    if (unify.engine.getTime() > worldResetTime && worldState > 0) setWorldState(0);

    throttleFrameCount++;

    if (gameStarted) {
      this.countdown = this.countdown - deltaTime;
      winOrLose();
    }
  };

  const setWorldState = state => {
    worldState = state;
    if (unify.modules.enemyController) unify.modules.enemyController.updateEnemyStates(state);

    switch (state) {
      case -1: // gameIdle
        // fire event
        worldStateCallbacks.forEach(func => {
          func(-1);
        });
        break;
      case 0: // neutral
        // fire event
        worldStateCallbacks.forEach(func => {
          func(0);
        });

        unify.assets.playerStats.powerUp = false;
        unify.assets.playerStats.isHunted = false;

        break;
      case 1: // good
        // fire event
        worldStateCallbacks.forEach(func => {
          func(1);
        });

        unify.assets.playerStats.powerUp = true;
        unify.assets.playerStats.isHunted = false;

        worldResetTime = unify.engine.getTime() + settings.powerUpDuration;

        break;
      case 2: // bad
        // fire event
        worldStateCallbacks.forEach(func => {
          func(2);
        });

        unify.assets.playerStats.powerUp = false;
        unify.assets.playerStats.isHunted = true;

        worldResetTime = unify.engine.getTime() + settings.vulnerableDuration;

        break;
    }
  };

  // Player Damage function
  this.playerHealth = damageAmount => {
    unify.assets.playerStats.health += damageAmount;
    if (unify.assets.playerStats.health > 100) unify.assets.playerStats.health = 100;
  };
  this.glitch = time => {
    unify.getModules().postEffects.glitch(time);
  };

  // Return random point on terrain
  this.RandomSpawnPoint = () => {
    let newX = Math.round(Math.random() * settings.playAreaSize);
    let newZ = Math.round(Math.random() * settings.playAreaSize);

    newX -= settings.playAreaSize * 0.5;
    newZ -= settings.playAreaSize * 0.5;

    let newY = terrainModule ? terrainModule.getTerrainHeight(newX, newZ) : 0;

    let newPosition = new THREE.Vector3(newX, newY, newZ);

    return newPosition;
  };

  // Events
  const gameStartedCallbacks = [];
  const gameEndedCallbacks = [];

  this.addEvent_WorldState = func => {
    if (!worldStateCallbacks.includes(func)) worldStateCallbacks.push(func);
  };
  this.addEvent_GameStarted = func => {
    if (!gameStartedCallbacks.includes(func)) {
      gameStartedCallbacks.push(func);
    }
  };
  this.addEvent_GameEnded = func => {
    if (!gameEndedCallbacks.includes(func)) {
      gameEndedCallbacks.push(func);
    }
  };
  this.removeEvent_WorldState = func => {
    for (let i = 0; i < earlyUpdateCallbacks.length; i++) {
      if (earlyUpdateCallbacks[i] === func) {
        worldStateCallbacks.splice(i, 1);
      }
    }
  };

  const addScore = () => {
    if (unify.assets.playerStats.score < 8) {
      unify.assets.playerStats.score++;
    }
  };

  const startGame = () => {
    gameStarted = true;
    setWorldState(0);
    // fire event
    gameStartedCallbacks.forEach(element => {
      element();
    });
    unify.input.removeMouseDown(startGame, "left");
    unify.input.removeKeyDown(restartGame, " ");
  };

  const endGame = () => {
    gameStarted = false;
    // fire event
    gameEndedCallbacks.forEach(element => {
      element();
    });
    unify.input.addKeyDown(restartGame, " ");
  };

  // Win or lose
  const winOrLose = () => {
    if (this.countdown > 0 && unify.assets.playerStats.health > 0 && unify.assets.playerStats.score == happyNugs.length) {
      endGame();
    } else if (unify.assets.playerStats.health <= 0 || this.countdown <= 0) {
      endGame();
    }
  };

  const restartGame = () => {
    location.reload();
  };

  // FOR PLAY TESTING PURPOSES ONLY - to be removed
  const setWorldStateNeutral = () => {
    setWorldState(0);
  };
  const setWorldStateGood = () => {
    setWorldState(1);
  };
  const setWorldStateBad = () => {
    setWorldState(2);
  };
  const addCountdown = () => {
    this.countdown += 60;
  };
};
